import type { BaseQueryFn } from '@reduxjs/toolkit/query';

/**
 * Since `createApi` requires us to specify a `baseQuery` function, we provide a no-op implementation.
 */
export const noopBaseQuery: BaseQueryFn<string, unknown, string> = () => {
  return { data: null };
};
